import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-search\"><path d=\"M944.96 875.008l-167.424-167.296a386.88 386.88 0 0 0 77.568-232.832 390.208 390.208 0 0 0-780.352 0.128 390.08 390.08 0 0 0 645.568 294.4l165.12 165.12a41.984 41.984 0 1 0 59.52-59.52z m-480-94.08A306.496 306.496 0 0 1 158.656 474.88a306.368 306.368 0 0 1 306.24-305.92 306.56 306.56 0 0 1 306.304 306.048 306.496 306.496 0 0 1-306.304 305.92z\" p-id=\"2700\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 41